// extracted by mini-css-extract-plugin
export default {"button":"IButton_button__MtNr9","primary":"IButton_primary__IOkm6","more":"IButton_more__-AV0g"};